export function isValidLastUpdatedAtIso(value: unknown): value is string {
  if (typeof value !== 'string') {
    return false;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }
  const parsed = Date.parse(trimmed);
  return Number.isFinite(parsed);
}

export function readLastUpdatedAtHint(hints?: Record<string, unknown> | null): string | undefined {
  const value = hints?.lastUpdatedAt;
  return isValidLastUpdatedAtIso(value) ? value.trim() : undefined;
}

/** Normalize a direct prop/callback value the same way as API hints. */
export function normalizeLastUpdatedAt(value?: string | null): string | undefined {
  return isValidLastUpdatedAtIso(value) ? value.trim() : undefined;
}
